import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Form, actions } from 'react-redux-form'
import { getSourceValue } from '../SubLeverCalculation/SubLeverFormula'
import ScrollArea from 'react-scrollbar'
import Modal from 'reboron/OutlineModal'
import { path } from 'Constants'
import AccountParametersNewValueStory from 'components/Spend/YourSpendFile/AccountParametersNewValueStory'
// Actions
import SaveSection from './SaveSection'
import {
	updateValueStoryName,
	updateCapIQId,
	updateOrganization,
	changeIndustry,
	changeLocation,
	updateTotalSpend,
	goToChoosePath,
	updateBPID, 
	updateANID,
	updateValueStoryType,
	updateRegion,
	isValueStoryPage,
	saveValueStoryOnRedirect,
	changeIndirectSolutionScope		
} from 'actions/discoveryActions'

import {
	toggleValueDriver,
	toggleSubLever
} from 'actions/valueDriverActions'

import {
	addValueStory,
	addValueStorySuccess,
	addValueStoryFailure,
	updateValueStory,
	updateValueStorySuccess,
	updateValueStoryFailure,
	openValueStory,
	openValueStorySuccess,
	openValueStoryFailure,
	valueStoryCurrentMenu,
	showValueStoryMenu,
	syncMenuAndButton,
	//resetError,
	setSubTabMenu,
	setTabMenu,
	requestFileBeforeValidation
}
	from 'actions/userActions'

import {
	isNewValueStory
} from 'actions/searchActions'

import { ActivetDeactiveCurrentRequest,getSccPercentageEvaluation,LoadRequestDetails,getYourRequestsDetails,setYourFileRequestDetails,getCapIQDataBlank,pendingChanges,defineScopeLoading,getYourFileFailure,getYourFileSuccess,setValueStoryDmciDetails,getYourFileLoading,loadRequestAfterVsCreate
	} from 'actions/spendActions'

import {
	initPrioritiesItems
}
	from 'actions/prioritiesActions'

import { valueStoryFetchDataSuccess } from 'actions/fetchValueStory'

// Common Functions
import { subLeverChange } from 'components/BusinessValue/SubLeverChange'

// Components
import DiscoveryForm from './DiscoveryForm'
import DiscoveryCompanyForm from './DiscoveryCompanyForm'
import DiscoveryButton from './DiscoveryButton'
import DiscoveryNextButton from './DiscoveryNextButton'
import SpendDiscoveryForm from './SpendDiscoveryForm'
import NewValueStory from './NewValueStory'
import NewValueStoryCreation from './NewValueStoryCreation'
import ValueStoryCreationForm from './ValueStoryCreationForm'
// UI
import Button from 'UI/Button'

// Utils
import classnames from 'classnames'
// Utils
import { removeMask, getSubLeverIdObject, subLeverHasTotalSpend, round } from 'utils/Utils'
import { updateUserInput } from 'actions/subLeverCalculationActions'

// Settings
import { routes, LAC, changeModalBorderStyle,drilldownModalBorderContentStyleNewVS, drilldownModalBorderContentStyleNewVsSecondPop, changeModalBorderRectStyle } from 'Constants'


export class SpendDiscoveryContainer extends PureComponent {

	constructor(props) {
		super(props)

		this.state = {
			interests: false,
			count: 0,
			regions: [],
			default: '',
			AnnualRevenue: 1,
			TotalSpend: 0,
			Currency: '$',
			CurrencyCode: 'USD',
			Organization: '',
			Industry: '',
			Location: '',
			CapIQId: '',
			CapIQCompany: '',
			PEId: '',
			PECompany: '',
			GlobalUltimateId: '',
			GlobalUltimateCompany: '',
			BPId: '',			
			BPCompany: '',
			isLoading:false,
			setSalesValueStoryOnError :false,
			fileDetails: [],
			//AllErrors: [],
			errorMsg:'',
			userData: undefined,
			btnCreateValueStoryDisabled: !this.props.form.valid, //|| Number.parseFloat(this.props.userData.AnnualRevenue) === 0
			btnCreateValueStoryDisabledNewVS: !this.props.form.valid, 
			reponseMessage: '',
			originalUserData: Object.assign({}, this.props.userData),
			scc_direct_spend_flag : 1,
			showPopup: false,
		}
		this.dispatchUpdateValueStoryName = this.dispatchUpdateValueStoryName.bind(this)
		this.dispatchUpdateCapIQId = this.dispatchUpdateCapIQId.bind(this)
		this.dispatchCapIQChange = this.dispatchCapIQChange.bind(this)
		this.dispatchUpdateOrganization = this.dispatchUpdateOrganization.bind(this)
		this.dispatchLocationChange = this.dispatchLocationChange.bind(this)
		this.dispatchRegionChange = this.dispatchRegionChange.bind(this)
		this.dispatchIndirectScopeChange = this.dispatchIndirectScopeChange.bind(this)
		
		this.dispatchIndustryChange = this.dispatchIndustryChange.bind(this)
		this.dispatchTotalSpendChange = this.dispatchTotalSpendChange.bind(this)
		this.dispatchRequestFileChange = this.dispatchRequestFileChange.bind(this)		
		this.slideToInterests = this.slideToInterests.bind(this)
		this.toggleInterestsVisibility = this.toggleInterestsVisibility.bind(this)
		this.initialFieldValues = this.initialFieldValues.bind(this)
		this.addValueStory = this.addValueStory.bind(this)
		//this.set_SCC_DIRECT_SPEND_FLG = this.set_SCC_DIRECT_SPEND_FLG.bind(this)
		this.openValueStory = this.openValueStory.bind(this)
		this.dispatchOpenValueStory = this.dispatchOpenValueStory.bind(this)
		this.redirect = this.redirect.bind(this)
		this.goToRoute = this.goToRoute.bind(this);
		this.handleValueStoryUpdate = this.handleValueStoryUpdate.bind(this)
		this.compareKeyValuesInObject = this.compareKeyValuesInObject.bind(this)
		this.compareKeyValuesInObjectNewVS = this.compareKeyValuesInObjectNewVS.bind(this)		
		this.actions = this.getApplicationFeatureActions();
		this.dispatchUpdateBPID = this.dispatchUpdateBPID.bind(this)
		this.dispatchUpdateANID = this.dispatchUpdateANID.bind(this)
		this.dispatchUpdateValueStoryType = this.dispatchUpdateValueStoryType.bind(this)
		this.generateValueStoryObject = this.generateValueStoryObject.bind(this)
		this.hideModal = this.hideModal.bind(this)
		this.routeToNewVSPopup = this.routeToNewVSPopup.bind(this)
		this.hideNewVSCreationPopup = this.hideNewVSCreationPopup.bind(this)	
	}	

	getApplicationFeatureActions() {
		let actions = [];
		let applicationFeatures = this.props.user && this.props.user.user && this.props.user.user.applicationFeatures ? this.props.user.user.applicationFeatures : [];
		applicationFeatures.map(applicationFeat => {
			actions.push(applicationFeat.Action);
		})
		return actions;
	}

	slideToInterests() {
		if (this.props.form.valid) {
			this.props.goToChoosePath(true)
		}
	}

	toggleInterestsVisibility() {
		const that = this
		that.setState({
			interests: !that.state.interests
		})
	}

	dispatchUpdateValueStoryName(valuestoryName) {
		this.props.updateValueStoryName(valuestoryName)
	}

	dispatchUpdateCapIQId(capiqid) {
		this.props.updateCapIQId(capiqid)
	}

	dispatchUpdateOrganization(organization) {
		this.props.updateOrganization(organization)
	}

	dispatchUpdateBPID(bpId){
		this.props.updateBPID(bpId)
	}

	dispatchUpdateANID(anId){
		this.props.updateANID(anId)
	}

	dispatchUpdateValueStoryType(valueStoryType){
        this.props.updateValueStoryType(valueStoryType)
	}	

	dispatchRegionChange(region){
		this.props.updateRegion(region)
	}

	dispatchCapIQChange(id) {
		this.setState({ capIQId: id })
	}
	dispatchIndirectScopeChange(index) {
		var industry = this.props.content.form.industries[index]
		var indirectScope = this.props.content.form.indirectScopes[index]
		var country = this.props.content.form.locations[this.props.userData.Location]
		var result = this.props.content.form.regions.find(region => region.Country.toLowerCase() == country.toLowerCase())
		var region = result.Region;
		var spend = this.props.subLeverCalculationContent.subLeverCalculation[0].rows[0][0].content
		var spendSourceValue = getSourceValue(3, country, region, industry, spend)		
		this.props.changeIndirectSolutionScope(indirectScope)
		
	}	

	dispatchLocationChange(location, region) {
		//New Logic to play with json values
		var industry = this.props.content.form.industries[this.props.userData.Industry]
		var country = this.props.content.form.locations[location]
		var spend = this.props.subLeverCalculationContent.subLeverCalculation[0].rows[0][0].content
		var spendSourceValue = getSourceValue(3, country, region, industry, spend)
		this.props.userData.Country_Name = country;
		this.props.changeLocation(location, spendSourceValue)
		// Turn off Reduce Cost of Processing Payments sub lever
		// if selected country is Latin American Country (LAC)
		if (LAC.indexOf(this.props.content.form.locations[this.props.userData.Location]) > -1) {
			const subLeverIdObject = {
				BVUIdIndex: 2,
				BVUSVDIdIndex: 2
			}
			// Dispatch to Redux
			this.props.toggleSubLever(subLeverIdObject, false)
		}
	}

	dispatchIndustryChange(index) {
		var industry = this.props.content.form.industries[index]
		var country = this.props.content.form.locations[this.props.userData.Location]
		var result = this.props.content.form.regions.find(region => region.Country.toLowerCase() == country.toLowerCase())
		var region = result.Region;
		var spend = this.props.subLeverCalculationContent.subLeverCalculation[0].rows[0][0].content
		var spendSourceValue = getSourceValue(3, country, region, industry, spend)
		this.props.changeIndustry(index, spendSourceValue)
	}

	dispatchTotalSpendChange(value) {
		this.formDispatch(actions.change('discovery.TotalSpend', value))
	}

	dispatchRequestFileChange(value)
	{
		this.formDispatch(actions.change('discovery.RequestId', value))
		this.setState({errorMsg : ''})
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.saveValueStoryAfterRedirect !== nextProps.saveValueStoryAfterRedirect && nextProps.saveValueStoryAfterRedirect) {
			this.handleValueStoryUpdate();
		}

		// Update controlled inputs on language, industry or total spend change
		if (this.props.content !== nextProps.content) {
			this.formDispatch(actions.change('discovery.Industry', nextProps.content.form.industries[this.props.userData.Industry]))
			this.formDispatch(actions.change('discovery.Region', nextProps.content.form.locations[this.props.userData.Region]))
			this.formDispatch(actions.change('discovery.Location', nextProps.content.form.locations[this.props.userData.Location]))
			this.formDispatch(actions.change('discovery.Organization', this.props.userData.Organization));
			this.formDispatch(actions.change('discovery.ValueStoryType', this.props.userData.ValueStoryType));			
		}

		if (nextProps.userData.ValueStoryName === "" || nextProps.userData.Industry === 0 || nextProps.userData.Industry === "" || nextProps.userData.Region === ""
			|| nextProps.userData.Organization === "" || !this.props.form.valid || nextProps.userData.ValueStoryType === "") {
			this.setState({ btnCreateValueStoryDisabled: true })
			//this.formDispatch(actions.change('discovery.Industry', nextProps.content.form.industries[this.props.userData.Industry]))
			//this.props.getCapIQDataBlank(true)
		} else {
			this.setState({ btnCreateValueStoryDisabled: false })
			//this.props.getCapIQDataBlank(false)
		}

		// this.setState({AllErrors : []});
		// var allErrorList = [];
		// if (this.state.btnCreateValueStoryDisabled == true) {
		// 	if(nextProps.userData.ValueStoryName === "") 
		// 		allErrorList.push('Please Enter Value Story Name');
		// 	if(nextProps.userData.Industry === "" || nextProps.userData.Industry === 0 ) 
		// 		allErrorList.push('Please Select Industry');
		// 	if(nextProps.userData.Organization === "") 
		// 		allErrorList.push('Please Enter Company Name');
		// 	if(nextProps.userData.ValueStoryType === "") 
		// 		allErrorList.push('Please Select Value Story Type');
		// 	if(nextProps.userData.Region === "") 
		// 		allErrorList.push('Please Select Region');	

		// 	this.setState({AllErrors : allErrorList});
		// }	

		if (nextProps.userData.Organization === "" || nextProps.userData.IndirectSolutionScope === undefined ||  nextProps.userData.requestFile === undefined) {
			this.setState({ btnCreateValueStoryDisabledNewVS: true })			
		} else {
			this.setState({ btnCreateValueStoryDisabledNewVS: false })			
		}
	}

	componentWillMount() {
		this.props.setTabMenu(1);
        this.props.setSubTabMenu(1);
		this.props.valueStoryCurrentMenu('Company');
		this.props.showValueStoryMenu(true);
		this.initialFieldValues();

	}

	componentDidMount() {
		// Load Request Id Start
		if (this.props.spendDetails.requestFileDetails.length === 0) {
			if (this.state.RequestIds === undefined || this.state.RequestIds.length === 0) {
			  this.props.getYourRequestsDetails(this.props.user.user.Email)
				.then(response => {
				  this.setState({ fileDetails: response.data.Result });
				  this.props.setYourFileRequestDetails(response.data.Result);				 
				  this.loadData();
				}).catch(res => {
				  this.props.setYourFileRequestDetails([]);
				  this.loadData();				  
				})
			}
		  }
		  else {
			//this.setDropDownData(this.props.spendDetails.requestFileDetails)
			this.setState({ fileDetails: this.props.spendDetails.requestFileDetails }, () => this.props.getYourFileSuccess());
			this.loadData();
		}		
	}

	loadData(){
		// Update Industry and spendAsPercentage
		//this.props.changeIndustry(this.props.userData.Industry, industryBusinessMatrix[this.props.userData.Industry].spendPercentage)
		var industry = this.props.content.form.industries[this.props.userData.Industry]
		var country = this.props.content.form.locations[this.props.userData.Location]
		if (industry && country) {
			var result = this.props.content.form.regions.find(region => region.Country.toLowerCase() == country.toLowerCase())
			var region = result.Region;
			var spend = this.props.subLeverCalculationContent.subLeverCalculation[0].rows[0][0].content
			var spendSourceValue = getSourceValue(3, country, region, industry, spend)
			this.props.changeIndustry(this.props.userData.Industry, spendSourceValue)
		}
		this.props.isValueStoryPage(true);
		// Navigation
		this.props.goToChoosePath(false);
		
		//Pass organization value to reducer forms
		this.formDispatch(actions.change('discovery.Organization', this.props.userData.Organization));
		this.formDispatch(actions.change('discovery.Industry', industry));

		//this.props.userData.ValueStoryType = this.state.originalUserData.ValueStoryType;

		if (this.props.newValueStory)
			this.refs.newValueStoryCreation.show();
	}

	initialFieldValues() {
		/*const companyData = this.props.companyData ? this.props.companyData[0] : undefined;
		if(companyData) {
			const industryIdx = this.props.content.form.industries.indexOf(companyData.Industry);
			const locationIdx = this.props.content.form.locations.indexOf(companyData.Location);
			companyData.Industry = industryIdx;
			companyData.Location = locationIdx;
		}*/
	}

	redirect(routeName) {
		this.props.history.push(routeName);
	}

	openValueStory(routeName) {
		this.dispatchOpenValueStory(routeName);
	}

	dispatchOpenValueStory(routeName) {
		var content = this.props.content;
		this.state.selectedValueStory &&
			this.props.openValueStory(this.state.selectedValueStory, this.props.user.user.Id)
				.then((response) => {
					if (response.status === 200) {
						// Push value story data to store
						this.props.valueStoryFetchDataSuccess(response.data.Result)

						// Add indexes of selected priorities to priorities array in store
						let items = response.data.Result.AreaOfInterest.map((item, i) => item.Selected && i)
						items = items.filter((item) => item !== false)
						this.props.initPrioritiesItems(items)
						this.props.isNewValueStory(false)
						// Reset form
						this.formDispatch(actions.reset('addValueStory'))

						var self = this;
						const calculatedTotalSpend = round(self.props.spendAsPercentageOfRevenue * response.data.Result["AnnualRevenue"], 2)
						if (response.data.Result["TotalSpend"] != calculatedTotalSpend) {
							const handleChange = this.props.handleChange
							this.props.subLeverCalculationContent.subLeverCalculation.forEach(function (obj) {

								const subLever = getSubLeverIdObject(obj.id)

								if (subLeverHasTotalSpend(obj.id)) {
									handleChange(response.data.Result["TotalSpend"], subLever, 0)
								}
							})
						}
						// Update Total Spend in state
						this.props.updateTotalSpend(response.data.Result["TotalSpend"])

						// Update controlled input
						this.dispatchTotalSpendChange(response.data.Result["TotalSpend"])

						this.setState({ originalUserData: Object.assign({}, this.props.userData) })

						// Redirect to Discovery page
						this.redirect(routeName)

						// update store status message
						// this.props.openValueStorySuccess()

						// reset store status message
						//setTimeout(() => {this.props.resetMessage()}, 100)
					}
					else {
						var httpStattus = response.response.data.Message
						var failMsg = content[httpStattus]
						if (failMsg !== undefined) {
							failMsg = failMsg.toString().replace("%userName%", response.response.data.Result)
							this.props.openValueStoryFailure(failMsg)
						}
					}
				}).catch((error) => {
					//this.props.openValueStoryFailure(error.response.data.Message)
				})
	}

	generateValueStoryObject() {
		return {
			ValueStoryDetails:
			{
				ValueStoryName: this.props.userData.ValueStoryName
				, Organization: this.props.userData.Organization
				, Industry: this.props.userData.Industry
				, Location: this.props.userData.Location
				, Currency: this.props.userData.Currency
				, AnnualRevenue: this.props.userData.AnnualRevenue
				, CreatedDate: this.props.userData.CreatedDate
				, ModifiedDate: this.props.userData.ModifiedDate
				, Id: this.props.userData.Id
				, MutualActionPlan: this.props.userData.MutualActionPlan
				, TotalSpend: this.props.userData.TotalSpend
				, PEId: this.props.userData.PEId
				, PECompany: this.props.userData.PECompany
				, BPId_old: this.props.userData.BPId_old
				, BPCompany: this.props.userData.BPCompany
				, CapIQId: this.props.userData.CapIQId
				, CapIQCompany: this.props.userData.CapIQCompany
				, GlobalUltimateId: this.props.userData.GlobalUltimateId
				, GlobalUltimateCompany: this.props.userData.GlobalUltimateCompany
				, CurrencyCode: this.props.userData.CurrencyCode
				, Test: this.props.userData.Test
				, ANID: this.props.userData.ANId
				, BPID: this.props.userData.BPId
				, ValueStoryType: this.props.userData.ValueStoryType
				, IndirectSolutionScope: this.props.userData.IndirectSolutionScope
				,Region: this.props.userData.Region
			}
			, TransactionEligible: this.props.userData.TransactionEligible
			, UnclassifiedEligible: this.props.userData.UnclassifiedEligible
			, SCCEligible: this.props.userData.SCCEligible
			, Fieldglass: this.props.userData.Fieldglass
			, FieldglassEligible: this.props.userData.FieldglassEligible
			, SuppEligible: this.props.userData.SuppEligible
			, CatalogScope: this.props.userData.CatalogScope
			, OutScopeSuspendedSup: this.props.userData.OutScopeSuspendedSup
			, SearchSupplierWave: this.props.userData.SearchSupplierWave
			, DirConnTransBuyReln: this.props.userData.DirConnTransBuyReln
			, MatchConfidence: this.props.userData.MatchConfidence
			, SCC_DIRECT_SPEND_FLG: this.props.userData.IndirectSolutionScope == 'Supply Chain Collaboration' ? this.state.scc_direct_spend_flag : null

		}
	}

	// set_SCC_DIRECT_SPEND_FLG(value)
	// {
	// 	this.setState({scc_direct_spend_flag : value});
	// }

	async addValueStory(routeName) {

		// WAIT for background validation to finish
		if (this.validationPromise) {
			await this.validationPromise;
	
			// // 🔥 if background validation had error, stop addValueStory
			// if (this.validationError) {
			// 	this.props.addValueStoryFailure(this.validationError);
			// 	return;
			// }
		}

		var content = this.props.content;
		//let values = Object.assign({}, formValues)
		this.props.userData.Language = this.props.language.toUpperCase()
		this.props.userData.Id = this.props.user.user.Id
		if (this.props.userData.AnnualRevenue === 0 || this.props.userData.AnnualRevenue === null) {
			this.props.userData.AnnualRevenue = this.state.AnnualRevenue;
			this.props.userData.TotalSpend = round(this.props.spendAsPercentageOfRevenue * this.state.AnnualRevenue, 2)
		}
		//values.TotalSpend = removeMask(values.TotalSpend, values.Currency)
		//values.AnnualRevenue = removeMask(values.AnnualRevenue, values.Currency)

		//Organization have taken from state
		//values.Organization = this.state.selectedPEName
		//values.PEId = this.state.selectedPEId
		var vsObject = this.generateValueStoryObject();

		var loadRequestFile = true;
		if (this.validationError.includes('Error:'))
			loadRequestFile = false;
		else if(this.validationError.includes('Warning:') && vsObject.ValueStoryDetails.ValueStoryType == 'EnablementExecution')
			vsObject.ValueStoryDetails.ValueStoryType = 'Sales';
		else if(this.validationError.includes('Warning:') && vsObject.ValueStoryDetails.ValueStoryType == 'Sales')
			this.validationError = '';
// Need to add remaining condition if error and warning both are present.

		this.props.addValueStory(vsObject)
			.then((result) => {
				if (result.status === 200) {
					// Open Value Story
					this.setState({
						selectedValueStory: result.data.Result.VSId,
						reponseMessage: this.props.content.createValueStorySuccess
					}, () => {
						
						let dmcId = this.props.userData.requestFile;						
						var loadRequestAfterVsCreateParam = {isNewVS : true, DMC_ID : dmcId, isLoadRequest: loadRequestFile,errorMsg:this.validationError}
						this.props.loadRequestAfterVsCreate(loadRequestAfterVsCreateParam);

						this.props.getYourFileSuccess(this.getMessage("200"));
						this.setState({  isLoading : false });
						this.openValueStory(routeName);

						// if (this.validationError.includes('Error: Request/ Spend files with Aggregate Invoice Count or Aggregate PO Count higher than 99,999,999 are by design not supported by AVATAR because these values are not possible and your file has an error.'))
						// {
						// 	this.props.getYourFileSuccess(this.getMessage("200"));
						// 	this.setState({  isLoading : false });
						// 	this.openValueStory(routeName);
						// }
						// else
						// 	this.loadRequesfileAfterVsCreate(result.data.Result.VSId,routeName);
						//this.openValueStory(routeName);
					})
				}
				else {
					var httpStattus = result.response.status;
					var failMsg = content[httpStattus]
					if (failMsg !== undefined) {
						failMsg = failMsg.toString().replace("%ValueStoryName%", this.props.userData.ValueStoryName)
						failMsg = failMsg.toString().replace("%Organization%", this.props.userData.Organization)
						//formValues.valueStoryName
						this.props.addValueStoryFailure(failMsg)
					}
					else {
						this.props.addValueStoryFailure(result.response.data.Message)

					}
				}

			}).catch((error) => {
				var httpStattus = error.response.status;
				var failMsg = content[httpStattus]
				if (failMsg !== undefined) {
					failMsg = failMsg.toString().replace("%ValueStoryName%", this.props.userData.ValueStoryName)
					failMsg = failMsg.toString().replace("%Organization%", this.props.userData.Organization)
					//formValues.valueStoryName
					this.props.addValueStoryFailure(failMsg)
				}
				else {
					this.props.addValueStoryFailure(error.response.data.Message)

				}
			})
	}

	handlePopupChoiceForSolutionScope(choiceValue) {
		this.setState(
			{
				showPopup: false,
				scc_direct_spend_flag: choiceValue, // store 1 / 2 / 3
			},
			() => {
				this.setState({ btnCreateValueStoryDisabled: true, isLoading: true }, () => this.addValueStory(routes.yourSpend));

			}
		);
	}

	goToRoute(routeName) {
		if (this.props.newValueStory) {
			if (this.props.userData.IndirectSolutionScope == 'Supply Chain Collaboration') {
				var request = { DMCID: this.props.userData.requestFile, VSID: -1, Email: this.props.user.user.Email }

				this.props.getSccPercentageEvaluation(request).then((result) => {
					if (result.status === 200) {
						if (result.data.Result[0].LOGIC == 'TRUE') {

							this.setState({
								showPopup: true,
							});
							return; // stop here until user chooses

						}
						else {
							this.setState({ btnCreateValueStoryDisabled: true, isLoading: true }, () => this.addValueStory(routeName));
						}
					}
				}).catch((error) => {
				});

			}
			else {
				this.setState({ btnCreateValueStoryDisabled: true, isLoading: true }, () => this.addValueStory(routeName));

			}
			//this.addValueStory(routeName);
		} else {
			if (this.props.form.valid && Number.parseFloat(this.props.userData.AnnualRevenue) !== 0) {
				this.props.history.push(routeName);
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			}
		}
	}
	

	compareKeyValuesInObject(originalUserData, userData) {
		this.props.pendingChanges(null);
		// If loadrequest validation is run and we made Value story type as Sales forcefully. then do not check validation
		if (this.props.checkFormValidation) {			
			if (originalUserData !== undefined && originalUserData !== null) {
				if (originalUserData['Industry'] === userData['Industry']
					&& originalUserData['Location'] === userData['Location']
					&& originalUserData['ValueStoryName'] === userData['ValueStoryName']
					&& originalUserData['CapIQId'] === userData['CapIQId']
					&& originalUserData['Organization'] === userData['Organization']
					&& originalUserData['BPId'] === userData['BPId']
					&& originalUserData['ANId'] === userData['ANId']
					&& originalUserData['ValueStoryType'] === userData['ValueStoryType']
					&& originalUserData['IndirectSolutionScope'] === userData['IndirectSolutionScope']
					&& originalUserData['Region'] === userData['Region']
				) {
					return true;
				}
				else {
					if (!this.props.form.valid)
						return true;
					else {
						this.props.pendingChanges(true);
						return false;
					}
				}
			}
			else {
				return true;
			}
		}
		else {
			this.props.updateCheckFormValidation();
			return true;
		}
	}

	compareKeyValuesInObjectNewVS(originalUserData, userData) {
		this.props.pendingChanges(null);		
		if (originalUserData !== undefined && originalUserData !== null) {
			if (
				originalUserData['Organization'] === userData['Organization']				
				&& originalUserData['IndirectSolutionScope'] === userData['IndirectSolutionScope']
				) {
				return true;
			}
			else {
				if (!this.props.form.valid)
					return true;
				else
				{
					this.props.pendingChanges(true);
					return false;
				}
			}
		}
		else {
			return true;
		}
	}

	componentWillUnmount() {
		//this.props.defineScopeLoading(false)
		setTimeout(() => {
			//this.props.userData.ValueStoryType = this.state.originalUserData.ValueStoryType;
			this.state.originalUserData.ValueStoryType = this.props.userData.ValueStoryType
			this.props.pendingChanges(null);
			this.props.isValueStoryPage(false);
		}, 1000);
		
		//this.props.resetError();
	}

	handleValueStoryUpdate() {
		this.setState({ isLoading: true })
		this.props.updateValueStoryFailure("")
		this.props.getYourFileFailure("");
		this.props.getYourFileSuccess("");
		let val = this.props.userData;
		this.props.updateValueStory(this.props.userData)
			.then((result) => {
				if (result.status === 200) {					
					this.setState({ reponseMessage: this.props.content.updateValueStorySuccess,isLoading: false })
					this.setState({ originalUserData: Object.assign({}, this.props.userData) })

					//-- Update All Request Region
					const updatedArray = this.props.spendDetails.valueStoryRequestDetails.map(item => ({
						...item,
						REGION_CD: this.props.userData.Region,
					  }));
					  this.props.setValueStoryDmciDetails(updatedArray);
					  this.props.spendDetails.currentActiveRequest.REGION_CD = this.props.userData.Region;
					//--					
				}
				else {
					this.props.updateValueStoryFailure(this.props.content.updatealueStoryFailure)
				}
				this.props.saveValueStoryOnRedirect(false);
			}).catch((error) => {
				// if (error.response) {
				// 	if (error.response.status === 400) {
				// 	  // 👇 Capture and display error message sent by backend
				// 	  const errorMessage = error.response.data.Message;
				// 	  console.error('400 Error:', errorMessage);
				// 	  this.props.updateValueStoryFailure(errorMessage);
				// 	//   this.props.userData.ValueStoryType = 'Sales';
				// 	var originalData = this.state.originalUserData;
				// 	// this.props.userData.ValueStoryType = 'EnablementExecution'
				// 	// this.setState({ originalUserData: Object.assign({}, this.props.userData) })			
				// 	originalData.ValueStoryType = 'Sales';
				// 	this.setState({ originalUserData: Object.assign({}, originalData),isLoading: false })					  
				// 	} else {
				// 		this.props.updateValueStoryFailure(this.props.content.updatealueStoryFailure)
				// 	}
				// 	this.props.saveValueStoryOnRedirect(false);
				// 	this.props.pendingChanges(null);
				//   }
				// //this.props.updateValueStoryFailure(this.props.content.updatealueStoryFailure)
			})

		// this.setState({ originalUserData: Object.assign({}, this.props.userData) })
	}

	handleMouseEnter(e) {
		const selectedButton = e.target.innerText;
		this.props.syncMenuAndButton(selectedButton)
	}

	handleMouseLeave = () => {
		this.props.syncMenuAndButton('')
	}

	hideModal()
	{
		this.refs.newValueStory.hide();
		this.props.history.push(`/start`)
		////this.props.history.push(`/start`)
	}

	hideNewVSCreationPopup()
	{
		this.refs.newValueStoryCreation.hide();
		this.props.history.push(`/start`)
	}

	// getRequestData(selectedRequestId, isNewRequest,VsId,routeName) {
	// 	this.setState({  disableRequestFileGrid : true });
	// 	if (selectedRequestId !== '') {
	// 	  var selectedRequest = selectedRequestId;
	// 	  var selectedRequestDetails = this.state.fileDetails.filter((element) =>
	// 		(element.DMC_ID === selectedRequest));
	// 	  selectedRequestDetails[0].VS_ID = VsId;
	// 	  selectedRequestDetails[0].User_Id = this.props.user.user.Id;
	// 	  selectedRequestDetails[0].SAPRequester = this.props.user.user.Email
	// 	  this.props.LoadRequestDetails(selectedRequestDetails[0], isNewRequest).then((response) => {
	// 		//console.log(response.data.StatusCode===200);
	// 		if (response.data.StatusCode === 200) {
	// 		  this.props.setValueStoryDmciDetails(response.data.Result);
	// 		  //this.setState({ allRequestOfVSIDnDMCID: response.data.Result , disableRequestFileGrid : false}, () => this.setActiveRequest())
	// 		  response.data.Result[0].ACTIVE_FLAG = true;
	// 		  this.props.ActivetDeactiveCurrentRequest(response.data.Result[0]).then({});
	// 		}
	// 		else {
	// 		  this.props.setValueStoryDmciDetails([]);
	// 		  //this.setState({ allRequestOfVSIDnDMCID: '' }, () => this.setActiveRequest())
	// 		}
	// 		this.props.getYourFileSuccess(this.getMessage("200"));
	// 		this.setState({  isLoading : false });
	// 		this.openValueStory(routeName);
	// 	  }).catch(error => {
	// 		if (error.response) {
	// 			if (error.response.status === 400) {
	// 			  // 👇 Capture and display error message sent by backend
	// 			  const errorMessage = error.response.data.Message;
	// 			  console.error('400 Error:', errorMessage);
	// 			  this.props.getYourFileFailure(errorMessage);
	// 			  //this.loadData();
	// 			} else {
	// 			  this.props.getYourFileFailure(this.getMessage('error'));
	// 			}
	// 			this.openValueStory(routeName);
	// 			//this.setState({  disableRequestFileGrid : false });
	// 			this.setState({  isLoading : false });
	// 		  }	  
	// 	  })
	// 	} 
	//   }

	  getMessage(keyToFindMessage) {
		return this.props.content[keyToFindMessage];
	  }
	

	// loadRequesfileAfterVsCreate111(VsId,routeName)
	// {
	// 	let dmcId = this.props.userData.requestFile
    
    //     this.props.getYourFileFailure("");
    //     this.props.getYourFileSuccess("");
    //     this.setState({ isRequestLoaded: true }) // to disable the load button
    //     this.props.getYourFileLoading(true);        
        
    //     this.getRequestData(dmcId, true,VsId,routeName);        

    //     this.setState({ isRequestLoaded: false}) // to unable the load button
	// }

	// routeToNewVSPopup()
	// {
	// 	this.setState({errorMsg: '',isLoading: true})
	// 	var data = { ValueStoryDetails: { VSId: -1 }, DMC_Id: this.props.userData.requestFile, Flag : 'VS_LOAD' };
	// 	this.props.requestFileBeforeValidation(data)
    //           .then((response) => {
    //             if (response.data.Result.length > 0) {
	// 				if (this.props.user.userprofile.Roles[0].indexOf("Delivery Partner User") > -1 || this.props.user.userprofile.Roles[0].indexOf("Delivery Internal User") > -1) {
	// 					var originalData = this.state.originalUserData;
	// 					originalData.ValueStoryType = 'EnablementExecution';
	// 					this.props.userData.ValueStoryType = 'EnablementExecution';
	// 					this.setState({ originalUserData: Object.assign({}, originalData) });
	// 				}
	// 				this.props.userData.ValueStoryName =  this.props.userData.Organization + ' - ' + this.props.userData.IndirectSolutionScope;
	// 				this.refs.newValueStoryCreation.hide();
	// 				this.refs.newValueStory.show();
	// 				this.setState({errorMsg: '',isLoading: false})
	// 				////this.props.history.push(`/start`)
    //             }               
    //           }).catch((error) => {

	// 			  if (error.response) {
	// 				  if (error.response.status === 400) {
	// 					  const errorMessage = error.response.data.Message;
	// 					  console.error('400 Error:', errorMessage);
	// 					  setTimeout(function() {
	// 						  //alert(errorMessage);
	// 						  if (errorMessage.includes('Error: Request/ Spend files with Aggregate Invoice Count or Aggregate PO Count higher than 99,999,999 are by design not supported by AVATAR because these values are not possible and your file has an error.'))
	// 							  this.setState({ errorMsg: errorMessage,isLoading: false})
	// 						  else {
	// 							  this.props.userData.ValueStoryName = this.props.userData.Organization + ' - ' + this.props.userData.IndirectSolutionScope;
								  
	// 							  var originalData = this.state.originalUserData;
	// 							  originalData.ValueStoryType = 'Sales';
	// 							  this.setState({ originalUserData: Object.assign({}, originalData),isLoading: false,setSalesValueStoryOnError :true });
								 
	// 							  this.refs.newValueStoryCreation.hide();
	// 							  this.refs.newValueStory.show();								  
	// 						  }
	// 					  }.bind(this), 1000)
	// 				  }
	// 			  }               

    //           });
	// }


	routeToNewVSPopup() {
		// normal UI flow (NO loading now)
		this.setState({ errorMsg: '', isLoading: false });

		// 1️⃣ Immediate UI updates
		if (
			this.props.user.userprofile.Roles[0].includes("Delivery Partner User") ||
			this.props.user.userprofile.Roles[0].includes("Delivery Internal User")
		) {
			const originalData = { ...this.state.originalUserData };
			originalData.ValueStoryType = 'EnablementExecution';
			this.props.userData.ValueStoryType = 'EnablementExecution';

			this.setState({ originalUserData: originalData });
		}

		// Get Value Story Type after Hana Validation
		// 🔥 Background API call — STORE PROMISE HERE
		const dataVsType = {
			ValueStoryDetails: { VSId: -1 },
			DMC_Id: this.props.userData.requestFile,
			Flag: 'DMC_VS_TYPE'
		};

		this.validationPromise = this.props.requestFileBeforeValidation(dataVsType)
			.then((response) => {
				//alert(response.data.Message);
				const originalData = { ...this.state.originalUserData };
				originalData.ValueStoryType = response.data.Message;
				this.props.userData.ValueStoryType = response.data.Message;

				this.setState({ originalUserData: originalData });

				this.props.userData.ValueStoryName =
					this.props.userData.Organization + ' - ' + this.props.userData.IndirectSolutionScope;

				// open next popup immediately (no waiting)
				this.refs.newValueStoryCreation.hide();
				this.refs.newValueStory.show();
			});



		// 🔥 Background API call — STORE PROMISE HERE
		const data = {
			ValueStoryDetails: { VSId: -1 },
			DMC_Id: this.props.userData.requestFile,
			Flag: 'VS_LOAD'
		};

		this.validationPromise = this.props.requestFileBeforeValidation(data)
			.then((res) => {
				console.log("Background validation success");
				this.validationError = "";
				return res;
			})
			.catch((error) => {

				let err = "Unknown error";

				if (error && error.response && error.response.data && error.response.data.Message) {
					err = error.response.data.Message;
				}

				console.error("Validation error:", err);

				// Save error for later
				this.validationError = err;

				return Promise.resolve(); // prevent crash
			});
	}

	render() {
		
		//let slideClasses = classnames('discovery__slide')

		if (this.props.valueStoryIsLoading) {
			return <p>Loading...</p>
		} else {
			return (
				<div className="discovery">
					<div >
						<Form
						    //className="grid-x medium-12" 
							model="discovery"
							getDispatch={(dispatch) => this.formDispatch = dispatch}
						>
							<div className="grid-x medium-12 grid-padding-x">								
								<div className="medium-12 cell">
								<SaveSection
									isUnchanged={this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData)}
									isLoading={this.state.isLoading}
									error={this.props.user.error}
									responseMessage={this.state.reponseMessage}
									pendingUpdates={this.props.content.pendingUpdates}
									onSave={this.handleValueStoryUpdate}
									content={this.props.content}
									newValueStory={this.props.newValueStory}
								/>
									<SpendDiscoveryForm  //ValueStoryCreationForm
										key={this.props.spendDetails.sdFormRefreshKey}																	
										content={this.props.content.form}
										subLeverCalculationContent={this.props.subLeverCalculationContent.subLeverCalculation}
										dispatchLocationChange={this.dispatchLocationChange}
										dispatchRegionChange={this.dispatchRegionChange}
										dispatchIndirectScopeChange={this.dispatchIndirectScopeChange}
										dispatchIndustryChange={this.dispatchIndustryChange}
										dispatchTotalSpendChange={this.dispatchTotalSpendChange}
										dispatchUpdateTotalSpend={this.props.updateTotalSpend}
										dispatchUpdateValueStoryName={this.dispatchUpdateValueStoryName}
										dispatchUpdateCapIQId={this.dispatchUpdateCapIQId}
										dispatchUpdateOrganization={this.dispatchUpdateOrganization}
										dispatchCapIQChange={this.dispatchCapIQChange}
										dispatchUpdateBPID={this.dispatchUpdateBPID}
										dispatchUpdateANID={this.dispatchUpdateANID}
										dispatchUpdateValueStoryType={this.dispatchUpdateValueStoryType}
										isNewValueStory={this.props.newValueStory}										
										originalUserData={this.state.originalUserData}
										compareKeyValuesInObject={this.compareKeyValuesInObject}
										responseMessage={this.state.reponseMessage}
									/>
									<SaveSection
										isUnchanged={this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData)}
										isLoading={this.state.isLoading}
										error={this.props.user.error}
										responseMessage={this.state.reponseMessage}
										pendingUpdates={this.props.content.pendingUpdates}
										onSave={this.handleValueStoryUpdate}
										content={this.props.content}
										newValueStory={this.props.newValueStory}
									/>
								</div>
							</div>
						</Form>
					</div>

					<Modal
                    ref={'newValueStory'}
                    modalStyle={changeModalBorderStyle}
                    contentStyle={drilldownModalBorderContentStyleNewVsSecondPop}
                    rectStyle={changeModalBorderRectStyle}                   
                    keyboard={false}
                    backdrop={false}
                   >
                    <div >
						<Form
						    //className="grid-x medium-12" 
							model="discovery"
							getDispatch={(dispatch) => this.formDispatch = dispatch}
						>
														
							 <div>
									<div className="medium-6">
									<div style={{marginLeft:"550px",fontWeight:"bold"}}>
											Create a New Value Story
										</div>
									</div>
									<div className="medium-6 popupOkBtn">
										<div className="float-right">
											<div className="float-left"><Button
												content={"X"}
												onClick={() => this.hideModal()}
												color /></div>
										</div>
									</div>
								{/*<div className="medium-12 cell"> */}
									<NewValueStory  //ValueStoryCreationForm
										content={this.props.content.form}
										subLeverCalculationContent={this.props.subLeverCalculationContent.subLeverCalculation}
										dispatchLocationChange={this.dispatchLocationChange}
										dispatchRegionChange={this.dispatchRegionChange}
										dispatchIndirectScopeChange={this.dispatchIndirectScopeChange}
										dispatchIndustryChange={this.dispatchIndustryChange}
										dispatchTotalSpendChange={this.dispatchTotalSpendChange}
										dispatchUpdateTotalSpend={this.props.updateTotalSpend}
										dispatchUpdateValueStoryName={this.dispatchUpdateValueStoryName}
										dispatchUpdateCapIQId={this.dispatchUpdateCapIQId}
										dispatchUpdateOrganization={this.dispatchUpdateOrganization}
										dispatchCapIQChange={this.dispatchCapIQChange}
										dispatchUpdateBPID={this.dispatchUpdateBPID}
										dispatchUpdateANID={this.dispatchUpdateANID}
										dispatchUpdateValueStoryType={this.dispatchUpdateValueStoryType}
										isNewValueStory={this.props.newValueStory}										
										originalUserData={this.state.originalUserData}
										compareKeyValuesInObject={this.compareKeyValuesInObject}
										responseMessage={this.state.reponseMessage}
										setSalesValueStoryOnError={this.state.setSalesValueStoryOnError}
										//set_SCC_DIRECT_SPEND_FLG = {this.set_SCC_DIRECT_SPEND_FLG}
										//scc_direct_spend_flag={this.state.scc_direct_spend_flag}
									/>
									<div className="formBg profile-pg">
										<div className="grid-x">
											<div className={
												classnames(
													'medium-8',
													{ 'errors': !this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData) },
													{ 'success': this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData) }
												)}>
												{this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData) ?
													this.state.reponseMessage : this.props.newValueStory ? '' : this.props.content.pendingUpdates}
											</div>
											{/* <div className={classnames('medium-8', 'errors')}>

												{this.state.AllErrors.map((err, index) => {
													return <li key={index}>{err}</li>
												})}
											</div> */}
											<div className="medium-12 cell" style={{ paddingLeft: '233px' }}>
												{this.props.newValueStory ?
													(!this.state.isLoading) ?
													<div className="float-right" >
														<button className={classnames('button button--accent',
															(this.props.hoverButton === this.props.content.buttons.goToPriorities) ? 'hoverStyle' : null)}
															disabled={this.state.btnCreateValueStoryDisabled}
															onClick={(e) => { this.goToRoute(routes.yourSpend) }}
															onMouseEnter={(e) => this.handleMouseEnter(e)} onMouseLeave={this.handleMouseLeave}>
															<span className="button__inner">{this.props.content.buttons.createValueStory}</span>
														</button>
													</div> : <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} src={path + `images/ajax-loader.gif`} alt="" />

													 :
													<div className="float-right" >
														<button className={classnames('button button--accent')}
															disabled={this.compareKeyValuesInObject(this.state.originalUserData, this.props.userData)}
															//disabled={_.isEqual(this.state.originalUserData, this.props.userData)}
															onClick={(e) => { this.handleValueStoryUpdate() }}>
															<span className="button__inner">{this.props.content.buttons.btnSaveValuesStory}</span>
														</button>
													</div>}
											</div>
										</div>
									</div>
								{/* </div> */}
								{/* <div className="medium-6 cell">
									<AccountParametersNewValueStory />
								</div> */}
							</div>
						</Form>
					</div>
					</Modal>

					<Modal
                    ref={'newValueStoryCreation'}
                    modalStyle={changeModalBorderStyle}
                    contentStyle={drilldownModalBorderContentStyleNewVS}
                    rectStyle={changeModalBorderRectStyle}                   
                    keyboard={false}
                    backdrop={false}
                   >
                    <div >
						<Form
						    //className="grid-x medium-12" 
							model="discovery"
							getDispatch={(dispatch) => this.formDispatch = dispatch}
						>
														
							 <div>
									<div className="medium-6">
										<div style={{marginLeft:"550px",fontWeight:"bold"}}>
											Create a New Value Story
										</div>
									</div>
									<div className="medium-6 popupOkBtn">
										<div className="float-right">
											<div className="float-left"><Button
												content={"X"}
												onClick={() => this.hideNewVSCreationPopup()}
												color /></div>
										</div>
									</div>
								{/*<div className="medium-12 cell"> */}
									<NewValueStoryCreation  //ValueStoryCreationForm
										content={this.props.content.form}
										subLeverCalculationContent={this.props.subLeverCalculationContent.subLeverCalculation}
										dispatchLocationChange={this.dispatchLocationChange}
										dispatchIndirectScopeChange={this.dispatchIndirectScopeChange}
										dispatchIndustryChange={this.dispatchIndustryChange}
										dispatchTotalSpendChange={this.dispatchTotalSpendChange}
										dispatchUpdateTotalSpend={this.props.updateTotalSpend}
										dispatchUpdateValueStoryName={this.dispatchUpdateValueStoryName}
										dispatchUpdateCapIQId={this.dispatchUpdateCapIQId}
										dispatchUpdateOrganization={this.dispatchUpdateOrganization}
										dispatchCapIQChange={this.dispatchCapIQChange}
										dispatchUpdateBPID={this.dispatchUpdateBPID}
										dispatchUpdateANID={this.dispatchUpdateANID}
										dispatchUpdateValueStoryType={this.dispatchUpdateValueStoryType}
										isNewValueStory={this.props.newValueStory}										
										originalUserData={this.state.originalUserData}
										fileDetails = {this.state.fileDetails}
										compareKeyValuesInObjectNewVS={this.compareKeyValuesInObjectNewVS}
										responseMessage={this.state.reponseMessage}
										dispatchRequestFileChange = {this.dispatchRequestFileChange}
										//set_SCC_DIRECT_SPEND_FLG = {this.set_SCC_DIRECT_SPEND_FLG}									
									/>

					<div className="medium-12 large-12">
                        <div className='errors'>{this.state.errorMsg}</div>
                    </div>
									<div className="formBg profile-pg">
										<div className="grid-x">
											<div className="medium-12 cell" style={{ paddingLeft: '233px' }}>
												<div className="float-right" >
													{(!this.state.isLoading) ?
														<button className={classnames('button button--accent',
															(this.props.hoverButton === this.props.content.buttons.goToPriorities) ? 'hoverStyle' : null)}
															disabled={this.state.btnCreateValueStoryDisabledNewVS}
															onClick={(e) => { this.routeToNewVSPopup() }}
															onMouseEnter={(e) => this.handleMouseEnter(e)} onMouseLeave={this.handleMouseLeave}>
															<span className="button__inner">{'Next'}</span>
														</button>
														:
														<img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} src={path + `images/ajax-loader.gif`} alt="" />

													}
												</div>
											</div>
										</div>
									</div>
								{/* </div> */}
								{/* <div className="medium-6 cell">
									<AccountParametersNewValueStory />
								</div> */}
							</div>
						</Form>
					</div>
					</Modal>
					  {/* Popup */}
					{this.state.showPopup && (
						<div className="popup-overlay-scc">
							<div className="popup-box">
								<p>Are direct spend suppliers identified in the spend file by having Direct Spend marked yes? <br />Note: To be considered for SCC enablement supplier must be marked as Direct Spend.</p>
								<div className="popup-buttons">
									{[
										{ label: 'Please update Direct Spend for all supplier to Yes', value: 3 },
										{ label: 'Yes - Direct Spend data is correct in customer data', value: 1 },
										{ label: 'No - User will update Direct Spend data manually', value: 2 },
									].map((choice) => (
										<button
											key={choice.value}
											className="popup-btn"
											onClick={() => this.handlePopupChoiceForSolutionScope(choice.value)}
										>
											{choice.label}
										</button>
									))}
								</div>
							</div>
						</div>
					)}
				</div >
			)
		}
	}
}

const mapStateToProps = (state) => {
	return {
		language: state.language,
		ui: state.content.ui,
		content: state.content.discovery,
		subLeverCalculationContent: state.content.subLeverCalculations,
		user: state.default,
		userData: state.valueStory,
		spendAsPercentageOfRevenue: state.spendAsPercentageOfRevenue,
		form: state.discoveryForm.$form,
		slide: state.goToChoosePath,
		priorities: state.priorities,
		valueStoryHasErrored: state.valueStoryHasErrored,
		valueStoryIsLoading: state.valueStoryIsLoading,
		benchMarksData: state.benchMarksData,
		regions: state.regions,
		companyData: state.companyProfileData,
		selectedValueStory: state.selectedValueStory,
		newValueStory: state.isNewValueStory,
		hoverButton: state.syncMenuAndButton,
		saveValueStoryAfterRedirect : state.saveValueStoryOnRedirect.changes,		
		spendDetails: state.spendDetails
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateValueStoryName: (valuestoryName) => dispatch(updateValueStoryName(valuestoryName)),
		updateCapIQId: (capiqid) => dispatch(updateCapIQId(capiqid)),
		updateOrganization: (organization) => dispatch(updateOrganization(organization)),
		changeLocation: (location, spendAsPercentageOfRevenue) => dispatch(changeLocation(location, spendAsPercentageOfRevenue)),
		changeIndustry: (industry, spendAsPercentageOfRevenue) => dispatch(changeIndustry(industry, spendAsPercentageOfRevenue)),
		updateTotalSpend: (spend) => dispatch(updateTotalSpend(spend)),
		goToChoosePath: (bool) => dispatch(goToChoosePath(bool)),
		toggleValueDriver: (id, bool) => dispatch(toggleValueDriver(id, bool)),
		toggleSubLever: (id, bool) => dispatch(toggleSubLever(id, bool)),
		handleChange: (value, subLeverId, rowNumber) => dispatch(updateUserInput(value, subLeverId, rowNumber)),
		addValueStory: (formValues) => dispatch(addValueStory(formValues)),
		addValueStorySuccess: (valueStory) => dispatch(addValueStorySuccess(valueStory)),
		addValueStoryFailure: (error) => dispatch(addValueStoryFailure(error)),
		updateValueStory: (formValues) => dispatch(updateValueStory(formValues)),
		updateValueStorySuccess: (valueStory) => dispatch(updateValueStorySuccess(valueStory)),
		updateValueStoryFailure: (error) => dispatch(updateValueStoryFailure(error)),
		getYourFileFailure: error => dispatch(getYourFileFailure(error)),
		getYourFileSuccess: message => dispatch(getYourFileSuccess(message)),
		openValueStory: (VSId, Id) => dispatch(openValueStory(VSId, Id)),
		openValueStorySuccess: () => dispatch(openValueStorySuccess()),
		openValueStoryFailure: (error) => dispatch(openValueStoryFailure(error)),
		valueStoryFetchDataSuccess: (valueStory) => dispatch(valueStoryFetchDataSuccess(valueStory)),
		initPrioritiesItems: (items) => dispatch(initPrioritiesItems(items)),
		isNewValueStory: (data) => dispatch(isNewValueStory(data)),
		valueStoryCurrentMenu: (menuItem) => dispatch(valueStoryCurrentMenu(menuItem)),
		showValueStoryMenu: (menuItem) => dispatch(showValueStoryMenu(menuItem)),
		syncMenuAndButton: (selectedButton) => dispatch(syncMenuAndButton(selectedButton)),
		getCapIQDataBlank: bool => dispatch(getCapIQDataBlank(bool)),
		updateBPID: (data) => dispatch(updateBPID(data)),
		updateANID: (data) => dispatch(updateANID(data)),
		updateValueStoryType: (data) => dispatch(updateValueStoryType(data)),
		updateRegion: (data) => dispatch(updateRegion(data)),
		pendingChanges: changes => dispatch(pendingChanges(changes)),
		//resetError: () => dispatch(resetError()),
		defineScopeLoading: bool => dispatch(defineScopeLoading(bool)),
		setSubTabMenu:(val)=>dispatch(setSubTabMenu(val)),
        setTabMenu:(val)=>dispatch(setTabMenu(val)),
		isValueStoryPage:(obj)=>dispatch(isValueStoryPage(obj)),
		saveValueStoryOnRedirect: changes => dispatch(saveValueStoryOnRedirect(changes)),
		changeIndirectSolutionScope: (value) => dispatch(changeIndirectSolutionScope(value)),
		setValueStoryDmciDetails: (data) => dispatch(setValueStoryDmciDetails(data)),
		getYourFileLoading: bool => dispatch(getYourFileLoading(bool)),
		getYourRequestsDetails: (email) => dispatch(getYourRequestsDetails(email)),
		setYourFileRequestDetails: (requests) => dispatch(setYourFileRequestDetails(requests)),
		//LoadRequestDetails: (requestDetails, isNewRequest) => dispatch(LoadRequestDetails(requestDetails, isNewRequest)),
		requestFileBeforeValidation: (formValues) => dispatch(requestFileBeforeValidation(formValues)),
		getSccPercentageEvaluation:(request)=> dispatch(getSccPercentageEvaluation(request)),
		//ActivetDeactiveCurrentRequest: requestDetails => dispatch(ActivetDeactiveCurrentRequest(requestDetails)),
		loadRequestAfterVsCreate: (data) => dispatch(loadRequestAfterVsCreate(data)),	
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SpendDiscoveryContainer)